
// 该文件请运行npm run createNodeImageList命令自动生成
import business_ from '../assets/svg/business/-.svg';
import business__1 from '../assets/svg/business/-_1.svg';
import business__10 from '../assets/svg/business/-_10.svg';
import business__11 from '../assets/svg/business/-_11.svg';
import business__12 from '../assets/svg/business/-_12.svg';
import business__13 from '../assets/svg/business/-_13.svg';
import business__14 from '../assets/svg/business/-_14.svg';
import business__15 from '../assets/svg/business/-_15.svg';
import business__16 from '../assets/svg/business/-_16.svg';
import business__17 from '../assets/svg/business/-_17.svg';
import business__18 from '../assets/svg/business/-_18.svg';
import business__2 from '../assets/svg/business/-_2.svg';
import business__3 from '../assets/svg/business/-_3.svg';
import business__4 from '../assets/svg/business/-_4.svg';
import business__5 from '../assets/svg/business/-_5.svg';
import business__6 from '../assets/svg/business/-_6.svg';
import business__7 from '../assets/svg/business/-_7.svg';
import business__8 from '../assets/svg/business/-_8.svg';
import business__9 from '../assets/svg/business/-_9.svg';
import business_OAxitong from '../assets/svg/business/OAxitong.svg';
import business_changyongziyuan from '../assets/svg/business/changyongziyuan.svg';
import business_chuchashenpi from '../assets/svg/business/chuchashenpi.svg';
import business_fanwendengji from '../assets/svg/business/fanwendengji.svg';
import business_feizhengshiwendengji from '../assets/svg/business/feizhengshiwendengji.svg';
import business_gongwenjiaohuan from '../assets/svg/business/gongwenjiaohuan.svg';
import business_gongzuohuibao from '../assets/svg/business/gongzuohuibao.svg';
import business_gudingzichan from '../assets/svg/business/gudingzichan.svg';
import business_huiyiguanli from '../assets/svg/business/huiyiguanli.svg';
import business_huiyiyuding from '../assets/svg/business/huiyiyuding.svg';
import business_kaoqinguanli from '../assets/svg/business/kaoqinguanli.svg';
import business_qingxiujiashenqing from '../assets/svg/business/qingxiujiashenqing.svg';
import business_sannianjihua from '../assets/svg/business/sannianjihua.svg';
import business_tongzhifabu from '../assets/svg/business/tongzhifabu.svg';
import business_xiangmuguanli from '../assets/svg/business/xiangmuguanli.svg';
import business_xinxitougao from '../assets/svg/business/xinxitougao.svg';
import business_zhishichanquan from '../assets/svg/business/zhishichanquan.svg';
import business_zhongxindongtaifabu from '../assets/svg/business/zhongxindongtaifabu.svg';
import business_zongheshenpi from '../assets/svg/business/zongheshenpi.svg';
import education_DNA from '../assets/svg/education/DNA.svg';
import education_a1shilibiao from '../assets/svg/education/a-1-shilibiao.svg';
import education_a10yiliaoxiang from '../assets/svg/education/a-10-yiliaoxiang.svg';
import education_a11yiyongweishengzhi from '../assets/svg/education/a-11-yiyongweishengzhi.svg';
import education_a12huxi from '../assets/svg/education/a-12-huxi.svg';
import education_a13xiguan from '../assets/svg/education/a-13-xiguan.svg';
import education_a14zhutingqi from '../assets/svg/education/a-14-zhutingqi.svg';
import education_a15bingdu from '../assets/svg/education/a-15-bingdu.svg';
import education_a16yiyuan from '../assets/svg/education/a-16-yiyuan.svg';
import education_a17zhusheqi from '../assets/svg/education/a-17-zhusheqi.svg';
import education_a18xiguan from '../assets/svg/education/a-18-xiguan.svg';
import education_a19guaizhang from '../assets/svg/education/a-19guaizhang.svg';
import education_a2kouzhao from '../assets/svg/education/a-2-kouzhao.svg';
import education_a20shuye from '../assets/svg/education/a-20-shuye.svg';
import education_a3chuangkoutie from '../assets/svg/education/a-3-chuangkoutie.svg';
import education_a4lunyi from '../assets/svg/education/a-4-lunyi.svg';
import education_a5mianqian from '../assets/svg/education/a-5-mianqian.svg';
import education_a6jiancebi from '../assets/svg/education/a-6-jiancebi.svg';
import education_a7xinzang from '../assets/svg/education/a-7-xinzang.svg';
import education_a8DNA from '../assets/svg/education/a-8-DNA.svg';
import education_a9tizhongcheng from '../assets/svg/education/a-9-tizhongcheng.svg';
import education_abitong1 from '../assets/svg/education/a-bitong1.svg';
import education_ashu2 from '../assets/svg/education/a-shu2.svg';
import education_ashu4 from '../assets/svg/education/a-shu4.svg';
import education_ashu5 from '../assets/svg/education/a-shu5.svg';
import education_ashuben2 from '../assets/svg/education/a-shuben2.svg';
import education_ashuben3 from '../assets/svg/education/a-shuben3.svg';
import education_ashuben4 from '../assets/svg/education/a-shuben4.svg';
import education_axueshimao1 from '../assets/svg/education/a-xueshimao1.svg';
import education_baichui from '../assets/svg/education/baichui.svg';
import education_bijiben from '../assets/svg/education/bijiben.svg';
import education_bitong from '../assets/svg/education/bitong.svg';
import education_chizi from '../assets/svg/education/chizi.svg';
import education_chongdian from '../assets/svg/education/chongdian.svg';
import education_citie from '../assets/svg/education/citie.svg';
import education_daima from '../assets/svg/education/daima.svg';
import education_deng from '../assets/svg/education/deng.svg';
import education_dianliushiyan from '../assets/svg/education/dianliushiyan.svg';
import education_diqiu from '../assets/svg/education/diqiu.svg';
import education_diqiuyi from '../assets/svg/education/diqiuyi.svg';
import education_fanyi from '../assets/svg/education/fanyi.svg';
import education_gongwenbao from '../assets/svg/education/gongwenbao.svg';
import education_heiban from '../assets/svg/education/heiban.svg';
import education_huiyi from '../assets/svg/education/huiyi.svg';
import education_jiangbei from '../assets/svg/education/jiangbei.svg';
import education_jiaoxuelou from '../assets/svg/education/jiaoxuelou.svg';
import education_jinpai from '../assets/svg/education/jinpai.svg';
import education_jisuan from '../assets/svg/education/jisuan.svg';
import education_jisuanqi from '../assets/svg/education/jisuanqi.svg';
import education_naozhong from '../assets/svg/education/naozhong.svg';
import education_qianbi from '../assets/svg/education/qianbi.svg';
import education_sepan from '../assets/svg/education/sepan.svg';
import education_shiyan from '../assets/svg/education/shiyan.svg';
import education_shouji from '../assets/svg/education/shouji.svg';
import education_shuben from '../assets/svg/education/shuben.svg';
import education_shuxie from '../assets/svg/education/shuxie.svg';
import education_sousuo from '../assets/svg/education/sousuo.svg';
import education_suanpan from '../assets/svg/education/suanpan.svg';
import education_tianping from '../assets/svg/education/tianping.svg';
import education_tingzhenqi from '../assets/svg/education/tingzhenqi.svg';
import education_tiyu from '../assets/svg/education/tiyu.svg';
import education_wenjian from '../assets/svg/education/wenjian.svg';
import education_xianweijing from '../assets/svg/education/xianweijing.svg';
import education_xiaoheiban from '../assets/svg/education/xiaoheiban.svg';
import education_xiezizhuo from '../assets/svg/education/xiezizhuo.svg';
import education_xueshimao from '../assets/svg/education/xueshimao.svg';
import education_yuanpan from '../assets/svg/education/yuanpan.svg';
import festival_celianggongju from '../assets/svg/festival/celianggongju.svg';
import festival_chunjie from '../assets/svg/festival/chunjie.svg';
import festival_duanwujie from '../assets/svg/festival/duanwujie.svg';
import festival_ertongjie from '../assets/svg/festival/ertongjie.svg';
import festival_fuqinjie from '../assets/svg/festival/fuqinjie.svg';
import festival_ganenjie from '../assets/svg/festival/ganenjie.svg';
import festival_gongju from '../assets/svg/festival/gongju.svg';
import festival_hushijie from '../assets/svg/festival/hushijie.svg';
import festival_jiaoshijie from '../assets/svg/festival/jiaoshijie.svg';
import festival_laodongjie from '../assets/svg/festival/laodongjie.svg';
import festival_muqinjie from '../assets/svg/festival/muqinjie.svg';
import festival_nvshengjie from '../assets/svg/festival/nvshengjie.svg';
import festival_qingrenjie from '../assets/svg/festival/qingrenjie.svg';
import festival_qixi from '../assets/svg/festival/qixi.svg';
import festival_shengdanjie from '../assets/svg/festival/shengdanjie.svg';
import festival_shuang from '../assets/svg/festival/shuang.svg';
import festival_yuandan from '../assets/svg/festival/yuandan.svg';
import festival_yuanxiaojie from '../assets/svg/festival/yuanxiaojie.svg';
import festival_zhongqiujie from '../assets/svg/festival/zhongqiujie.svg';
import festival_zhongyangjie from '../assets/svg/festival/zhongyangjie.svg';
import food_binggan from '../assets/svg/food/binggan.svg';
import food_binggun from '../assets/svg/food/binggun.svg';
import food_bingqilin from '../assets/svg/food/bingqilin.svg';
import food_boluo from '../assets/svg/food/boluo.svg';
import food_caomei from '../assets/svg/food/caomei.svg';
import food_celianggongju from '../assets/svg/food/celianggongju.svg';
import food_chengzi from '../assets/svg/food/chengzi.svg';
import food_dangao from '../assets/svg/food/dangao.svg';
import food_fanqiejiang from '../assets/svg/food/fanqiejiang.svg';
import food_gongju from '../assets/svg/food/gongju.svg';
import food_hanbao from '../assets/svg/food/hanbao.svg';
import food_jiandan from '../assets/svg/food/jiandan.svg';
import food_kafeibei from '../assets/svg/food/kafeibei.svg';
import food_lajiao from '../assets/svg/food/lajiao.svg';
import food_naixi from '../assets/svg/food/naixi.svg';
import food_niunai from '../assets/svg/food/niunai.svg';
import food_pingguo from '../assets/svg/food/pingguo.svg';
import food_pisa from '../assets/svg/food/pisa.svg';
import food_putao from '../assets/svg/food/putao.svg';
import food_quqi from '../assets/svg/food/quqi.svg';
import food_regou from '../assets/svg/food/regou.svg';
import food_shutiao from '../assets/svg/food/shutiao.svg';
import food_sudaqishui from '../assets/svg/food/sudaqishui.svg';
import food_taozi from '../assets/svg/food/taozi.svg';
import food_tiantianquan from '../assets/svg/food/tiantianquan.svg';
import food_xiangjiao from '../assets/svg/food/xiangjiao.svg';
import food_xigua from '../assets/svg/food/xigua.svg';
import food_xilanhua from '../assets/svg/food/xilanhua.svg';
import food_yingtao from '../assets/svg/food/yingtao.svg';
import food_yumi from '../assets/svg/food/yumi.svg';
import medicine_a1shilibiao from '../assets/svg/medicine/a-1-shilibiao.svg';
import medicine_a10yiliaoxiang from '../assets/svg/medicine/a-10-yiliaoxiang.svg';
import medicine_a11yiyongweishengzhi from '../assets/svg/medicine/a-11-yiyongweishengzhi.svg';
import medicine_a12huxi from '../assets/svg/medicine/a-12-huxi.svg';
import medicine_a13xiguan from '../assets/svg/medicine/a-13-xiguan.svg';
import medicine_a14zhutingqi from '../assets/svg/medicine/a-14-zhutingqi.svg';
import medicine_a15bingdu from '../assets/svg/medicine/a-15-bingdu.svg';
import medicine_a16yiyuan from '../assets/svg/medicine/a-16-yiyuan.svg';
import medicine_a17zhusheqi from '../assets/svg/medicine/a-17-zhusheqi.svg';
import medicine_a18xiguan from '../assets/svg/medicine/a-18-xiguan.svg';
import medicine_a19guaizhang from '../assets/svg/medicine/a-19guaizhang.svg';
import medicine_a2kouzhao from '../assets/svg/medicine/a-2-kouzhao.svg';
import medicine_a20shuye from '../assets/svg/medicine/a-20-shuye.svg';
import medicine_a3chuangkoutie from '../assets/svg/medicine/a-3-chuangkoutie.svg';
import medicine_a4lunyi from '../assets/svg/medicine/a-4-lunyi.svg';
import medicine_a5mianqian from '../assets/svg/medicine/a-5-mianqian.svg';
import medicine_a6jiancebi from '../assets/svg/medicine/a-6-jiancebi.svg';
import medicine_a7xinzang from '../assets/svg/medicine/a-7-xinzang.svg';
import medicine_a8DNA from '../assets/svg/medicine/a-8-DNA.svg';
import medicine_a9tizhongcheng from '../assets/svg/medicine/a-9-tizhongcheng.svg';
import tools_gaizhui from '../assets/svg/tools/gaizhui.svg';
import tools_ziyuan from '../assets/svg/tools/ziyuan.svg';
import tools_ziyuan_1 from '../assets/svg/tools/ziyuan_1.svg';
import tools_ziyuan_10 from '../assets/svg/tools/ziyuan_10.svg';
import tools_ziyuan_11 from '../assets/svg/tools/ziyuan_11.svg';
import tools_ziyuan_12 from '../assets/svg/tools/ziyuan_12.svg';
import tools_ziyuan_13 from '../assets/svg/tools/ziyuan_13.svg';
import tools_ziyuan_14 from '../assets/svg/tools/ziyuan_14.svg';
import tools_ziyuan_15 from '../assets/svg/tools/ziyuan_15.svg';
import tools_ziyuan_16 from '../assets/svg/tools/ziyuan_16.svg';
import tools_ziyuan_17 from '../assets/svg/tools/ziyuan_17.svg';
import tools_ziyuan_18 from '../assets/svg/tools/ziyuan_18.svg';
import tools_ziyuan_2 from '../assets/svg/tools/ziyuan_2.svg';
import tools_ziyuan_3 from '../assets/svg/tools/ziyuan_3.svg';
import tools_ziyuan_4 from '../assets/svg/tools/ziyuan_4.svg';
import tools_ziyuan_5 from '../assets/svg/tools/ziyuan_5.svg';
import tools_ziyuan_6 from '../assets/svg/tools/ziyuan_6.svg';
import tools_ziyuan_7 from '../assets/svg/tools/ziyuan_7.svg';
import tools_ziyuan_8 from '../assets/svg/tools/ziyuan_8.svg';
import tools_ziyuan_9 from '../assets/svg/tools/ziyuan_9.svg';
import travel_banshouli from '../assets/svg/travel/banshouli.svg';
import travel_chuhangshijian from '../assets/svg/travel/chuhangshijian.svg';
import travel_ditu from '../assets/svg/travel/ditu.svg';
import travel_fengjing from '../assets/svg/travel/fengjing.svg';
import travel_gonglve from '../assets/svg/travel/gonglve.svg';
import travel_hangli from '../assets/svg/travel/hangli.svg';
import travel_huafei from '../assets/svg/travel/huafei.svg';
import travel_jipiao from '../assets/svg/travel/jipiao.svg';
import travel_jiudian from '../assets/svg/travel/jiudian.svg';
import travel_lvban from '../assets/svg/travel/lvban.svg';
import travel_meishi from '../assets/svg/travel/meishi.svg';
import travel_menpiao from '../assets/svg/travel/menpiao.svg';
import travel_paishe from '../assets/svg/travel/paishe.svg';
import travel_qianzheng from '../assets/svg/travel/qianzheng.svg';
import travel_shangdian from '../assets/svg/travel/shangdian.svg';
import travel_tianqi from '../assets/svg/travel/tianqi.svg';
import travel_youlechangsuo from '../assets/svg/travel/youlechangsuo.svg';
import travel_yuyanfanyi from '../assets/svg/travel/yuyanfanyi.svg';
import travel_zhuyishixiang from '../assets/svg/travel/zhuyishixiang.svg';
import travel_zuche from '../assets/svg/travel/zuche.svg';
export default [
  {
    'name': '商务',
    'list': [
      {
        'url': business_,
        'width': 100,
        'height': 100
      },
      {
        'url': business__1,
        'width': 100,
        'height': 100
      },
      {
        'url': business__10,
        'width': 100,
        'height': 100
      },
      {
        'url': business__11,
        'width': 100,
        'height': 100
      },
      {
        'url': business__12,
        'width': 100,
        'height': 100
      },
      {
        'url': business__13,
        'width': 100,
        'height': 100
      },
      {
        'url': business__14,
        'width': 100,
        'height': 100
      },
      {
        'url': business__15,
        'width': 100,
        'height': 100
      },
      {
        'url': business__16,
        'width': 100,
        'height': 100
      },
      {
        'url': business__17,
        'width': 100,
        'height': 100
      },
      {
        'url': business__18,
        'width': 100,
        'height': 100
      },
      {
        'url': business__2,
        'width': 100,
        'height': 100
      },
      {
        'url': business__3,
        'width': 100,
        'height': 100
      },
      {
        'url': business__4,
        'width': 100,
        'height': 100
      },
      {
        'url': business__5,
        'width': 100,
        'height': 100
      },
      {
        'url': business__6,
        'width': 100,
        'height': 100
      },
      {
        'url': business__7,
        'width': 100,
        'height': 100
      },
      {
        'url': business__8,
        'width': 100,
        'height': 100
      },
      {
        'url': business__9,
        'width': 100,
        'height': 100
      },
      {
        'url': business_OAxitong,
        'width': 100,
        'height': 100
      },
      {
        'url': business_changyongziyuan,
        'width': 100,
        'height': 100
      },
      {
        'url': business_chuchashenpi,
        'width': 100,
        'height': 100
      },
      {
        'url': business_fanwendengji,
        'width': 100,
        'height': 100
      },
      {
        'url': business_feizhengshiwendengji,
        'width': 100,
        'height': 100
      },
      {
        'url': business_gongwenjiaohuan,
        'width': 100,
        'height': 100
      },
      {
        'url': business_gongzuohuibao,
        'width': 100,
        'height': 100
      },
      {
        'url': business_gudingzichan,
        'width': 100,
        'height': 100
      },
      {
        'url': business_huiyiguanli,
        'width': 100,
        'height': 100
      },
      {
        'url': business_huiyiyuding,
        'width': 100,
        'height': 100
      },
      {
        'url': business_kaoqinguanli,
        'width': 100,
        'height': 100
      },
      {
        'url': business_qingxiujiashenqing,
        'width': 100,
        'height': 100
      },
      {
        'url': business_sannianjihua,
        'width': 100,
        'height': 100
      },
      {
        'url': business_tongzhifabu,
        'width': 100,
        'height': 100
      },
      {
        'url': business_xiangmuguanli,
        'width': 100,
        'height': 100
      },
      {
        'url': business_xinxitougao,
        'width': 100,
        'height': 100
      },
      {
        'url': business_zhishichanquan,
        'width': 100,
        'height': 100
      },
      {
        'url': business_zhongxindongtaifabu,
        'width': 100,
        'height': 100
      },
      {
        'url': business_zongheshenpi,
        'width': 100,
        'height': 100
      }
    ]
  },
  {
    'name': '教育',
    'list': [
      {
        'url': education_DNA,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a1shilibiao,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a10yiliaoxiang,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a11yiyongweishengzhi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a12huxi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a13xiguan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a14zhutingqi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a15bingdu,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a16yiyuan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a17zhusheqi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a18xiguan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a19guaizhang,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a2kouzhao,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a20shuye,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a3chuangkoutie,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a4lunyi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a5mianqian,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a6jiancebi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a7xinzang,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a8DNA,
        'width': 100,
        'height': 100
      },
      {
        'url': education_a9tizhongcheng,
        'width': 100,
        'height': 100
      },
      {
        'url': education_abitong1,
        'width': 100,
        'height': 100
      },
      {
        'url': education_ashu2,
        'width': 100,
        'height': 100
      },
      {
        'url': education_ashu4,
        'width': 100,
        'height': 100
      },
      {
        'url': education_ashu5,
        'width': 100,
        'height': 100
      },
      {
        'url': education_ashuben2,
        'width': 100,
        'height': 100
      },
      {
        'url': education_ashuben3,
        'width': 100,
        'height': 100
      },
      {
        'url': education_ashuben4,
        'width': 100,
        'height': 100
      },
      {
        'url': education_axueshimao1,
        'width': 100,
        'height': 100
      },
      {
        'url': education_baichui,
        'width': 100,
        'height': 100
      },
      {
        'url': education_bijiben,
        'width': 100,
        'height': 100
      },
      {
        'url': education_bitong,
        'width': 100,
        'height': 100
      },
      {
        'url': education_chizi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_chongdian,
        'width': 100,
        'height': 100
      },
      {
        'url': education_citie,
        'width': 100,
        'height': 100
      },
      {
        'url': education_daima,
        'width': 100,
        'height': 100
      },
      {
        'url': education_deng,
        'width': 100,
        'height': 100
      },
      {
        'url': education_dianliushiyan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_diqiu,
        'width': 100,
        'height': 100
      },
      {
        'url': education_diqiuyi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_fanyi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_gongwenbao,
        'width': 100,
        'height': 100
      },
      {
        'url': education_heiban,
        'width': 100,
        'height': 100
      },
      {
        'url': education_huiyi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_jiangbei,
        'width': 100,
        'height': 100
      },
      {
        'url': education_jiaoxuelou,
        'width': 100,
        'height': 100
      },
      {
        'url': education_jinpai,
        'width': 100,
        'height': 100
      },
      {
        'url': education_jisuan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_jisuanqi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_naozhong,
        'width': 100,
        'height': 100
      },
      {
        'url': education_qianbi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_sepan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_shiyan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_shouji,
        'width': 100,
        'height': 100
      },
      {
        'url': education_shuben,
        'width': 100,
        'height': 100
      },
      {
        'url': education_shuxie,
        'width': 100,
        'height': 100
      },
      {
        'url': education_sousuo,
        'width': 100,
        'height': 100
      },
      {
        'url': education_suanpan,
        'width': 100,
        'height': 100
      },
      {
        'url': education_tianping,
        'width': 100,
        'height': 100
      },
      {
        'url': education_tingzhenqi,
        'width': 100,
        'height': 100
      },
      {
        'url': education_tiyu,
        'width': 100,
        'height': 100
      },
      {
        'url': education_wenjian,
        'width': 100,
        'height': 100
      },
      {
        'url': education_xianweijing,
        'width': 100,
        'height': 100
      },
      {
        'url': education_xiaoheiban,
        'width': 100,
        'height': 100
      },
      {
        'url': education_xiezizhuo,
        'width': 100,
        'height': 100
      },
      {
        'url': education_xueshimao,
        'width': 100,
        'height': 100
      },
      {
        'url': education_yuanpan,
        'width': 100,
        'height': 100
      }
    ]
  },
  {
    'name': '节日',
    'list': [
      {
        'url': festival_celianggongju,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_chunjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_duanwujie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_ertongjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_fuqinjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_ganenjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_gongju,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_hushijie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_jiaoshijie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_laodongjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_muqinjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_nvshengjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_qingrenjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_qixi,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_shengdanjie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_shuang,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_yuandan,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_yuanxiaojie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_zhongqiujie,
        'width': 100,
        'height': 100
      },
      {
        'url': festival_zhongyangjie,
        'width': 100,
        'height': 100
      }
    ]
  },
  {
    'name': '食物',
    'list': [
      {
        'url': food_binggan,
        'width': 100,
        'height': 100
      },
      {
        'url': food_binggun,
        'width': 100,
        'height': 100
      },
      {
        'url': food_bingqilin,
        'width': 100,
        'height': 100
      },
      {
        'url': food_boluo,
        'width': 100,
        'height': 100
      },
      {
        'url': food_caomei,
        'width': 100,
        'height': 100
      },
      {
        'url': food_celianggongju,
        'width': 100,
        'height': 100
      },
      {
        'url': food_chengzi,
        'width': 100,
        'height': 100
      },
      {
        'url': food_dangao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_fanqiejiang,
        'width': 100,
        'height': 100
      },
      {
        'url': food_gongju,
        'width': 100,
        'height': 100
      },
      {
        'url': food_hanbao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_jiandan,
        'width': 100,
        'height': 100
      },
      {
        'url': food_kafeibei,
        'width': 100,
        'height': 100
      },
      {
        'url': food_lajiao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_naixi,
        'width': 100,
        'height': 100
      },
      {
        'url': food_niunai,
        'width': 100,
        'height': 100
      },
      {
        'url': food_pingguo,
        'width': 100,
        'height': 100
      },
      {
        'url': food_pisa,
        'width': 100,
        'height': 100
      },
      {
        'url': food_putao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_quqi,
        'width': 100,
        'height': 100
      },
      {
        'url': food_regou,
        'width': 100,
        'height': 100
      },
      {
        'url': food_shutiao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_sudaqishui,
        'width': 100,
        'height': 100
      },
      {
        'url': food_taozi,
        'width': 100,
        'height': 100
      },
      {
        'url': food_tiantianquan,
        'width': 100,
        'height': 100
      },
      {
        'url': food_xiangjiao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_xigua,
        'width': 100,
        'height': 100
      },
      {
        'url': food_xilanhua,
        'width': 100,
        'height': 100
      },
      {
        'url': food_yingtao,
        'width': 100,
        'height': 100
      },
      {
        'url': food_yumi,
        'width': 100,
        'height': 100
      }
    ]
  },
  {
    'name': '医疗',
    'list': [
      {
        'url': medicine_a1shilibiao,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a10yiliaoxiang,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a11yiyongweishengzhi,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a12huxi,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a13xiguan,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a14zhutingqi,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a15bingdu,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a16yiyuan,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a17zhusheqi,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a18xiguan,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a19guaizhang,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a2kouzhao,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a20shuye,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a3chuangkoutie,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a4lunyi,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a5mianqian,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a6jiancebi,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a7xinzang,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a8DNA,
        'width': 100,
        'height': 100
      },
      {
        'url': medicine_a9tizhongcheng,
        'width': 100,
        'height': 100
      }
    ]
  },
  {
    'name': '工具',
    'list': [
      {
        'url': tools_gaizhui,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_1,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_10,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_11,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_12,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_13,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_14,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_15,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_16,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_17,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_18,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_2,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_3,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_4,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_5,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_6,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_7,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_8,
        'width': 100,
        'height': 100
      },
      {
        'url': tools_ziyuan_9,
        'width': 100,
        'height': 100
      }
    ]
  },
  {
    'name': '旅行',
    'list': [
      {
        'url': travel_banshouli,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_chuhangshijian,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_ditu,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_fengjing,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_gonglve,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_hangli,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_huafei,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_jipiao,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_jiudian,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_lvban,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_meishi,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_menpiao,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_paishe,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_qianzheng,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_shangdian,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_tianqi,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_youlechangsuo,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_yuyanfanyi,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_zhuyishixiang,
        'width': 100,
        'height': 100
      },
      {
        'url': travel_zuche,
        'width': 100,
        'height': 100
      }
    ]
  }
];
